var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8ExpensivePrice1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 8C8.76318 8 1.59998 15.1632 1.59998 24C1.59998 32.8368 8.76318 40 17.6 40C26.4368 40 33.6 32.8368 33.6 24C33.6 15.1632 26.4368 8 17.6 8ZM29.6062 9.03125C33.9886 12.5497 36.8 17.9424 36.8 24C36.8 30.0576 33.9886 35.4503 29.6062 38.9688C35.6734 36.6952 40 30.8608 40 24C40 17.1392 35.6734 11.3049 29.6062 9.03125ZM36.0062 9.03125C40.3886 12.5497 43.2 17.9424 43.2 24C43.2 30.0576 40.3886 35.4503 36.0062 38.9688C42.0734 36.6952 46.4 30.8608 46.4 24C46.4 17.1392 42.0734 11.3049 36.0062 9.03125Z",
    fill: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6062 9.03125C33.9886 12.5496 36.8 17.9424 36.8 24C36.8 30.0576 33.9886 35.4503 29.6062 38.9688C35.6734 36.6952 40 30.8608 40 24C40 17.1392 35.6734 11.3049 29.6062 9.03125Z",
    fill: "#FFD708"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ExpensivePrice1);
export default __webpack_public_path__ + "static/media/icons8-expensive-price 1.2ef30e16e972093aeb21f6f77a73e552.svg";
export { ForwardRef as ReactComponent };